<template>
  <div class="d-flex align-center">
    <!-- <div class="caption">Client id: {{ clientId }}</div>
    <div class="caption">Selected ids: {{ value }} {{ selectedHotlistRecipients }}</div>
    <div class="caption">Recipients: {{ items }}</div> -->
    <div class="gridLink" @click="showDialog = true">
      <div>
        {{ selectedHotlistRecipients }}
      </div>
    </div>
    <v-btn v-if="!selectedHotlistRecipients" text small color="primary" @click="showDialog = true"
      ><v-icon small class="mr-1">mdi-plus</v-icon
      >{{ selectedHotlistRecipients ? 'Edit recipients' : 'Add Recipients' }}</v-btn
    >

    <SelectHotlistRecipientsDialog
      v-model="showDialog"
      :call-id="callId"
      :client-id="clientId"
      :selected-contact-ids="value"
      :hotlistId="hotlistId"
      @recipients-updated="emit('recipients-updated')" />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import SelectHotlistRecipientsDialog from './SelectHotlistRecipientsDialog.vue';

interface SelectRecipientsProps {
  callId: string;
  value: number[];
  clientId: number;
  hotlistId: number;
  allRecipients: any[];
}

const props = withDefaults(defineProps<SelectRecipientsProps>(), {
  value: () => [],
  allRecipients: () => [],
});

const emit = defineEmits<{
  (e: 'recipients-updated'): void;
}>();

const items = computed(() =>
  props.allRecipients.filter((item) => item.CLIENT_ID === props.clientId && props.hotlistId === item.HOTLIST_ID)
);

const selectedHotlistRecipients = computed(() =>
  items.value.map((item) => {
    if (item.FULL_NAME)
      return item.FULL_NAME.trim() === 'Company' ? 'Company Email' : item.FULL_NAME.trim();

    return "";
  }).join(', ')
);

const showDialog = ref(false);
</script>
